import React, { useState } from 'react'
import Chatbotcontent from './Chatbotcontent'
import Chatbutton from './Chatbutton'

function Chatbot({ settings, platformId, user_id, chatbot_id }) {
    const [showChatBot, setShowChatBot] = useState(false);

    function showchatbotfun() {
        setShowChatBot(true);
    }

    function hideChatbotfun() {
        setShowChatBot(false);
    }
    return (
        <>
            {
                showChatBot ?
                    <Chatbotcontent
                        hideChatbot={hideChatbotfun}
                        settings={settings}
                        platformId={platformId}
                        user_id={user_id}
                        chatbot_id={chatbot_id}
                    /> :
                    <Chatbutton
                    settings={settings}
                        showchatbot={showchatbotfun}
                    />
            }

        </>

    )
}

export default Chatbot